<template>
  <div>
    <MatterInfo ref="matterInfo" :title="title" :tag="tag" :itemId="itemId" @initPickType="initPickType">
      <div slot="content">
        <div class="swiperBox" style="margin-top:30px">
          <div class="allWrapp">
            <a-tabs default-active-key="1">
              <a-tab-pane key="1" >
                <span class="tabTitle" slot="tab">取件方式</span>
                <div>
                  <a-alert message="请选择取件方式" type="info" show-icon />
                </div>
                <div style="display: flex;margin-bottom: 30px">
                  <div @click="chooseType(0)">
                    <div class="typeclass" :style="isSelf === 0 ? 'border: 1px solid #1677FF' : 'margin-left: 2px'">
                      <img
                        style="width:65px;height:65px;"
                        src="./../../../assets/jiopweb3.0.0/get.png"
                        alt="" />
                      <div class="right">
                        <div class="fontTitle">自取</div>
                        <div class="fontSpec">短信通知取件地址</div>
                      </div>
                    </div>
                  </div>
                  <div @click="chooseType(1)">
                    <div class="typeclass" :style="isSelf === 1 ? 'border: 1px solid #1677FF;margin-left: 30px' : 'margin-left: 30px'">
                      <img
                        style="width:65px;height:65px;"
                        src="./../../../assets/jiopweb3.0.0/post.png"
                        alt="" />
                      <div class="right">
                        <div class="fontTitle">邮寄</div>
                        <div class="fontSpec">邮政速递，邮费到付</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="isSelf === 1">
                  <div class="address">
                    填写你的收件地址：
                  </div>
                  <a-form :form="form">
                    <a-row>
                      <a-col :span="8">
                        <a-form-item
                          label="收件人姓名"
                        >
                          <a-input
                            @input="watchData"
                            placeholder="请填写收件人姓名"
                            :max-length="50"
                            v-decorator="[
                              'name',
                              { rules: [{ pattern: /^(([\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+)*)|([A-Za-z]+[\s]?(·[A-Za-z]+)*))$/, message: '须是合法的姓名' }, { required: true, message: '收件人姓名不能为空' }] }
                            ]"
                            style="height: 40px;width: 260px"/>
                        </a-form-item>
                      </a-col>
                      <a-col :span="8">
                        <a-form-item
                          label="手机号码"
                        >
                          <a-input
                            @input="watchData"
                            placeholder="请填写收件人手机号码"
                            v-decorator="[
                              'mobile',
                              { rules: [{ pattern: /^(13|14|15|16|17|18|19)[0-9]{9}$/, message: '格式不正确' }, { required: true, message: '手机号码不能为空' }] }
                            ]"
                            style="height: 40px;width: 260px"/>
                        </a-form-item>
                      </a-col>
                      <a-col :span="8">
                        <a-form-item
                          label="所在地区"
                        >
                          <a-cascader
                            style="height: 40px;width: 260px"
                            label="省市级联查询"
                            :options="options"
                            placeholder="省/市/县（区）"
                            :max-length="50"
                            v-decorator="[
                              'area',
                              { rules: [{ required: true, message: '所在地区不能为空' }] }
                            ]"
                            @change="onChange" />
                        </a-form-item>

                      </a-col>

                    </a-row>
                    <a-row>
                      <a-col :span="24">
                        <a-form-item
                          label="详细地址"
                          class="only"
                        >
                          <a-input
                            @input="watchData"
                            placeholder="请填写详细地址"
                            :max-length="50"
                            v-decorator="[
                              'detailAddress',
                              { rules: [{ required: true, message: '详细地址不能为空' }] }
                            ]"
                            style="margin-left: 14px;height: 40px;width: 1008px"/>
                        </a-form-item>
                      </a-col>
                    </a-row>

                  </a-form>
                </div>
                <div v-if="isSelf === 0" style="margin-bottom: 24px;">
                  <!-- <div class="resTitle">结果自取提示</div> -->
                  <!-- <div v-for="item in tipData" :key="item.iid" class="tipword">
                    <div>{{ item.iid + '、' + item.question }}</div>
                    <div style="padding-left: 21px;">{{ item.answer }}</div>
                  </div> -->
                  <div class="tipword">
                    <span v-html="pickTypeContent"></span>
                  </div>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
          <div style="text-align:right;margin-top: 6px;" >
            <!-- 没按设计稿 -->
            <a-button style="height: 40px;width: 150px;" type="default" @click="previousStep">上一步</a-button>
            <a-tooltip style="margin-left: 10px">
              <template slot="title">
                <span>申请表会暂存到个人中心的办事记录中，可再次编辑</span>
              </template>
              <a-button style="height: 40px;width: 150px;margin-right:10px;margin-left:10px" type="default" @click="saveDraft">
                保存为草稿
                <a-icon type="info-circle" />
              </a-button>
            </a-tooltip>
            <a-button style="height: 40px;width: 150px;" type="primary" v-if="stepNo<total-1" @click="nextStep">下一步</a-button>
            <!-- <a-button style="height: 40px;width: 150px;" type="submit" v-else @click="nextStep">确认提交</a-button> -->
            <SubmitButton v-else />

            <!-- 按照设计稿 -->
            <!-- <a-button style="height: 50px;width: 150px;" type="default" @click="previousStep">上一步</a-button>
            <a-tooltip>
              <template slot="title">
                <span>申请表会暂存到个人中心的办事记录中，可再次编辑</span>
              </template>
              <div class="btnStyle2" @click="saveDraft">
                <span style="padding: 0px 8px 0px 8px">
                  保存为草稿
                </span>
                <a-icon type="info-circle" style="margin-right: 16px;margin-left: 10px;font-size: 18px;margin-top: 3px;"/>
              </div>
            </a-tooltip>
            <span class="btnStyle1" @click="nextStep" v-if="stepNo<total-1">下一步</span>
            <span class="btnStyle1" @click="submit" v-else>确认提交</span> -->
          </div>
        </div>
      </div>
    </MatterInfo>
    <!-- <CloseMessage ref="closemessage" @ok="goBack" @close="addState"/> -->
  </div>
</template>
<script>
import HMetaForm from 'jpaas-component/lib/HMetaForm'
import MatterInfo from '@/views/jiopweb/onlineDealWith/layout/matterInfo.vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { jiopWebAPI } from '@/api/jiopweb/jiopweb'
import aratOptions from './areaData.js'
import { sm2 } from 'sm-crypto'
import CloseMessage from './components/CloseMessage'
import SubmitButton from '@/views/jiopweb/onlineDealWith/components/submitButton.vue'
export default {
  name: 'ReceiveInfo',
  components: {
    SubmitButton,
    MatterInfo,
    HMetaForm,
    CloseMessage
  },
  data () {
    return {
      zhCN,
      itemId: this.$route.query.itemId,
      stepNo: this.$route.query.stepNo,
      total: this.$route.query.total,
      title: JSON.parse(sessionStorage.getItem(this.$route.query.itemId + '_matter')).matterName,
      tag: JSON.parse(sessionStorage.getItem(this.$route.query.itemId + '_matter')).tag,
      formData: { formTemplate: '', formConfig: {} },
      formMeta: {},
      model: {},
      cardLoading: false,
      pageNo: 1,
      matterId: '1a1b805b2f6345eebac132385a9cb429',
      size: 'large',
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      isSelf: 0,
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 15 }
      },
      tipData: [
        {
          iid: '1',
          question: '电子版如何获取？',
          answer: '办件审批通过后，办理结果的电子版可以在“个人中心的办事记录-办件详情”或“在首页办件查询后找到办件详情”中直接下载。'
        },
        {
          iid: '2',
          question: '如果需要实体证怎么办？',
          answer: '可自行打印电子版，或前往办事指南中提示的办事地点，凭办件编号领取实体证。'
        },
        {
          iid: '3',
          question: '怎么拿到实体证件？',
          answer: '您的办件办理成功后，我们会通过短信通知您具体的办事地点，可凭办件编号领取实体证。'
        }
      ],
      options: [],
      showValue: [],
      params: { receiveType: 0 },
      is_submit: true,
      pickTypeContent: ''
    }
  },
  mounted () {
    // 监听浏览器关闭
    window.addEventListener(
      'beforeunload',
      this.beforeunloadHandler, false)
    // if (window.history && window.history.pushState) {
    //   // 向历史记录中插入了当前页（为栈顶）
    //   // history.pushState(null, null, document.URL)
    //   window.addEventListener('popstate', this.goBack, false)
    // }
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.beforeunloadHandler, false)
    // window.removeEventListener('popstate', this.goBack, false)
  },
  created () {
    // 处理中国的行政区划
    this.setData(aratOptions)
    this.options = aratOptions
    // 获取缓存数据
    this.getSessionInfo()
    // this.init()
  },
  methods: {
    initPickType (content) {
      this.pickTypeContent = content
    },
    beforeunloadHandler (e) {
      e = e || window.event
      if (!this.is_submit) {
        if (e) {
          e.preventDefault()
          e.returnValue = '关闭提示'
        }
        return '关闭提示'
      }
    },
    // addState () {
    //   // 回退弹窗选择取消之后，history实体会注销，此时需要在插入一个实体
    //   if (window.history && window.history.pushState) {
    //   // 向历史记录中插入了当前页（为栈顶）
    //     history.pushState(null, null, document.URL)
    //   }
    // },
    // goBack (e) {
    //   if (e === 'true') {
    //     window.history.back(-2)
    //     // 回退
    //   } else {
    //     e = e || window.event
    //     if (!this.is_submit) {
    //       if (e) {
    //         this.$nextTick(() => {
    //           this.$refs.closemessage.visible = true
    //         })
    //       }
    //       return '关闭提示'
    //     } else {
    //       window.history.back(-2)
    //     }
    //   }
    // },
    setData (data) {
      data.forEach((item, index) => {
        if (item.value) {
          item.label = item.value
        } else {
          const params = { 'value': item, 'label': item }
          data.splice(index, 1, params)
        }
        if (item.children) {
          this.setData(item.children)
        }
      })
    },
    chooseType (type) {
      this.isSelf = type
      this.params = { receiveType: type }
      this.showValue = []
      this.form.setFieldsValue({
        area: undefined
      })
      sessionStorage.setItem(this.itemId + '_JiopwebReceive', JSON.stringify(this.params))
    },
    // 监听输入框中值的改变
    watchData (val) {
      this.is_submit = false
      if (val.target.id === 'name') {
        this.params.receiveUserName = this.form.getFieldValue('name')
      } else if (val.target.id === 'mobile') {
        this.params.receivePhone = this.form.getFieldValue('mobile')
      } else {
        this.params.receiveDetailArea = this.form.getFieldValue('detailAddress')
      }
      sessionStorage.setItem(this.itemId + '_JiopwebReceive', JSON.stringify(this.params))
    },
    getSessionInfo () {
      this.is_submit = true
      if (sessionStorage.getItem(this.itemId + '_JiopwebReceive')) {
        const params = JSON.parse(sessionStorage.getItem(this.itemId + '_JiopwebReceive'))
        this.isSelf = parseInt(params.receiveType)
        this.params = { receiveType: this.isSelf }
        if (this.isSelf === 1) {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              name: params.receiveUserName,
              mobile: params.receivePhone,
              detailAddress: params.receiveDetailArea,
              area: JSON.parse(params.receiveArea)
            })
            this.params.receiveUserName = this.form.getFieldValue('name')
            this.params.receivePhone = this.form.getFieldValue('mobile')
            this.params.receiveDetailArea = this.form.getFieldValue('detailAddress')
            this.params.receiveArea = JSON.stringify(this.showValue)
          })
          this.showValue = JSON.parse(params.receiveArea)
        }
      } else {
        sessionStorage.setItem(this.itemId + '_JiopwebReceive', JSON.stringify(this.params))
      }
    },
    submitDataHandle () {
      const that = this
      const jsonParams = sessionStorage.getItem(this.itemId + '_matter') ? JSON.parse(sessionStorage.getItem(this.itemId + '_matter')) : {} // 事项数据
      // 用户信息
      if (sessionStorage.getItem('JiopUserInfo')) {
        const userInfo = JSON.parse(sessionStorage.getItem('JiopUserInfo'))
        if (userInfo.isLogin) {
          const userParams = userInfo.desensitizeUser ? JSON.parse(userInfo.desensitizeUser) : {}
          jsonParams.applyUserId = userParams.uid ? userParams.uid : undefined
          jsonParams.applyUserName = userParams.name ? userParams.name : undefined // 姓名是加密发回的带星号
          jsonParams.steps = this.stepNo // 进度条
          jsonParams.situationSelect = sessionStorage.getItem(this.itemId + '_listOfSituations') // 情形选择
          jsonParams.formData = sessionStorage.getItem(this.itemId + '_infoStr') // 信息填报
          jsonParams.handleType = this.$route.query.handleType
          // 信息填报回显用（提交草稿是要传）
          jsonParams.model = sessionStorage.getItem(this.itemId + '_model')
          jsonParams.reportingprogress = '100'
          const uploadInfo = sessionStorage.getItem(this.itemId + '_JiopwebMaterial') ? JSON.parse(sessionStorage.getItem(this.itemId + '_JiopwebMaterial')) : []
          uploadInfo.forEach(item => {
            if (item.data && item.data.length > 0) {
              item.data.forEach(ele => {
                ele.base64 = ''
                ele.thumbUrl = ''
              })
            }
          })
          jsonParams.uploadMaterial = JSON.stringify(uploadInfo) // 材料
          // 取件方式
          if (this.isSelf === 0) {
            jsonParams.receiveType = 0
          } else {
            jsonParams.receiveType = 1
            jsonParams.receiveArea = JSON.stringify(this.showValue)
            jsonParams.receiveUserName = this.form.getFieldValue('name')
            jsonParams.receivePhone = this.form.getFieldValue('mobile')
            jsonParams.receiveDetailArea = this.form.getFieldValue('detailAddress')
          }
          const jsonstring = JSON.stringify(jsonParams)
          // jiopWebAPI.getPublicKey({ userId: jsonParams.applyUserId }).then(res => {
          jiopWebAPI.getPublicKey({ userType: 1, appType: 1 }).then(res => {
            if (res.success) {
              const publicKey = res.data.publicKey
              const encryptString = that.encrypt(jsonstring, publicKey)
              jiopWebAPI.materialSubmit({ infoStr: encryptString, applyUserId: jsonParams.applyUserId }).then(res => {
                if (res.success) {
                  that.is_submit = true
                  that.$message.success('已经存为草稿，请到用户空间-我的办件中查看')
                }
              })
            }
          })
        }
      }
    },
    saveDraft () {
      this.submitDataHandle()
      // 按要求不做校验
      // this.form.validateFields((err, values) => {
      //   if (!err) {
      //     this.submitDataHandle()
      //   }
      // })
    },
    encrypt: function (str, publicKey) {
      return '04' + sm2.doEncrypt(str, publicKey, 1)
    },
    handleFormLayoutChange (e) {
      this.formLayout = e.target.value
    },
    onChange (value) {
      this.showValue = value
      this.params.receiveArea = JSON.stringify(value)
      sessionStorage.setItem(this.itemId + '_JiopwebReceive', JSON.stringify(this.params))
    },
    previousStep () {
      this.$refs.matterInfo.previousStep()
    },
    nextStep () {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$refs.matterInfo.nextStep()
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.tabTitle{
  width: 88px;
  height: 22px;

  font-size: 22px;
  color: #1677FF;
  font-weight: 600;
}
.content{
  width: 1200px;
  margin: auto;
}
.swiperBox{
  box-shadow: 0px 2px 15px 0px rgba(153, 153, 153, 0.2);
  width: 1200px;
  // height: 120px;
  background: #ffffff;
  padding: 30px;
  margin: auto;
}
.btnStyle1 {
  height: 50px;
  width: 150px;
  display: inline-block;
  color: #fff;
  background: #1677ff;
  line-height: 50px;
  text-align: center;
  border: 1px solid #1677ff;
  border-radius: 2px;
  cursor: pointer;
  font-size: 16px;
  margin-left: 20px;
}
.btnStyle2 {
  height: 50px;
  width: 175px;
  margin-left: 20px;
  line-height: 50px;
  text-align: end;
  border: 1px solid #1677ff;
  border-radius: 2px;
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  color: #1677ff;
}
/deep/ .ant-tabs-ink-bar {
    position: absolute;
    bottom: 1px;
    left: 0;
    z-index: 1;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 0;
    height: 2px;
    background-color: #1677FF;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
}
/deep/ .ant-tabs-nav .ant-tabs-tab {
    position: relative;
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 100%;
    margin: 0 32px 0 0;
    padding: 0px 4px 19px 4px;
    text-decoration: none;
    cursor: pointer;
    -webkit-transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    font-size: 22px;
    font-weight: 600;
}
/deep/ .ant-tabs-nav .ant-tabs-tab-active {
    color: #1677FF;
    text-shadow: 0 0 0.25px currentColor;
}
/deep/ .ant-tabs-bar {
    margin: 0px 0 20px 0;
    border-bottom: 1px solid #e8e8e8;
    outline: none;
    -webkit-transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/deep/ .ant-alert-info {
    background-color: #EDF5FF;
    border: 1px solid #91d5ff;
    margin-bottom: 30px;
}
/deep/ .ant-alert-info .ant-alert-icon {
    color: #1677FF;
}
/deep/ .ant-alert-message {
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: 400;
}
// 设计稿样式
// /deep/ .ant-btn {
//     border-radius: 2px;
//     border-color: #1677FF;
//     color: #1677FF;
//     font-size: 16px;
// }
.typeclass {
  width: 320px;
  height: 120px;
  background: #FFFFFF;
  box-shadow: 0px 2px 15px 0px rgba(153,153,153,0.2);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-left: 30px;
}
.fontTitle {
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
  margin-bottom: 8px;
}
.fontSpec {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
}
.right {
  margin-left: 20px;
}
.resTitle {
  font-size: 16px;
  color: #333333;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 12px;
}
.tipword {
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 400;
}
.address {
  font-size: 16px;
  color: #333333;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 20px;
}
/deep/ .ant-row {
    position: relative;
    height: auto;
    margin-right: 0;
    margin-left: 0;
    zoom: 1;
    display: flex;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
/deep/ .ant-cascader-input.ant-input {
    position: static;
    width: 100%;
    padding-right: 24px;
    background-color: transparent !important;
    cursor: pointer;
    height: 40px;
}
/deep/ .only .has-error .ant-form-explain {
    color: #f5222d;
    margin-left: 14px;
}

</style>
